import apiTool from './index';

const GET_USERS_URL = 'kuser/getusers/';
const GET_PROVIDERS_URL = 'kuser/getproviders/';
const GET_SPECIFIC_USER = 'kuser/user/';
const UPDATE_USER_TAGS_URL = 'kuser/update-tags/';
const UPDATE_USER_COMPANIES_URL = 'kuser/update-companies/';
const UPDATE_USER_RESULTLINK_URL = 'kuser/update-resultlink/';
const DELETE_USER_URL = 'kuser/delete-user/';
const GET_DOCUMENTS_URL = 'documentation/get-all-documents/';
const GET_CATEGORIES_URL = 'documentation/get-categories/';
const ADD_DOCUMENT_URL = 'documentation/add-document/';
const EDIT_DOCUMENT_URL = 'documentation/update-document/';
const DELETE_DOCUMENT_URL = 'documentation/delete-document/';
const GET_DOCUMENT_URL = 'documentation/get-document/';
const ADD_CATEGORY_URL = 'documentation/add-category/';
const EDIT_CATEGORY_URL = 'documentation/update-category/';
const DELETE_CATEGORY_URL = 'documentation/delete-category/';
const GET_CATEGORY_URL = 'documentation/get-category/';
const GET_USERTYPES_URL = 'userprofile/get-usertypes/';
const ADD_USERTYPE_URL = 'userprofile/add-usertype/';
const GET_TAGS_URL = 'question/get-tags/';
const ADD_TAG_URL = 'question/add-tag/';
const GET_TAG_URL = 'question/get-tag/';
const UPDATE_TAG_URL = 'question/update-tag/';
const DELETE_TAG_URL = 'question/delete-tag/';


export default {
  updateUserTag(payload){
    return apiTool.post(UPDATE_USER_TAGS_URL, payload);
  },
  updateResultLink(payload){
    return apiTool.post(UPDATE_USER_RESULTLINK_URL, payload);
  },
  addUserType(payload){
    return apiTool.post(ADD_USERTYPE_URL, payload);
  },
  updateUserCompany(payload){
    return apiTool.post(UPDATE_USER_COMPANIES_URL, payload);
  },
  getSpecificUser(payload) {
    return apiTool.get(GET_SPECIFIC_USER + payload.id + '/')
  },
  getTags() {
    return apiTool.get(GET_TAGS_URL);
  },
  getTag(tag_id) {
    return apiTool.get(GET_TAG_URL + tag_id + '/');
  },
  addTag(payload) {
    return apiTool.post(ADD_TAG_URL, payload);
  },
  updateTag(payload) {
    return apiTool.post(UPDATE_TAG_URL + payload.id + '/', payload);
  },
  deleteTag(question_id) {
    return apiTool.delete(DELETE_TAG_URL + question_id + '/');
  },
  getUsers(payload){
    return apiTool.post(GET_USERS_URL, payload);
  },
  getProviders(payload){
    return apiTool.post(GET_PROVIDERS_URL, payload);
  },
  deleteUser(userId) {
    return apiTool.post(DELETE_USER_URL + userId + '/');
  },
  getDocuments(target) {
    return apiTool.post(GET_DOCUMENTS_URL, {target:target});
  },
  getCategories() {
    return apiTool.get(GET_CATEGORIES_URL);
  },
  addDocument(payload) {
    return apiTool.post(ADD_DOCUMENT_URL, payload);
  },
  editDocument(document_id, payload) {
    return apiTool.post(EDIT_DOCUMENT_URL+ document_id + '/', payload);
  },
  deleteDocument(document_id) {
    return apiTool.delete(DELETE_DOCUMENT_URL + document_id + '/');
  },
  getDocument(document_id) {
    return apiTool.get(GET_DOCUMENT_URL + document_id + '/');
  },
  addCategory(payload) {
    return apiTool.post(ADD_CATEGORY_URL, payload);
  },
  editCategory(document_id, payload) {
    return apiTool.post(EDIT_CATEGORY_URL+ document_id + '/', payload);
  },
  deleteCategory(document_id) {
    return apiTool.delete(DELETE_CATEGORY_URL + document_id + '/');
  },
  getCategory(document_id) {
    return apiTool.get(GET_CATEGORY_URL + document_id + '/');
  },
  getUserTypes() {
    return apiTool.get(GET_USERTYPES_URL);
  }
};
